import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../types/store';
import { AppDispatch } from '../store/store';
import { processOperationQueue } from '../store/map3PendingSlice';

const QUEUE_PROCESS_DELAY = 100; // ms

export function useOperationQueue() {
  const dispatch = useDispatch<AppDispatch>();
  const queueTimer = useRef<NodeJS.Timeout | null>(null);
  const { operations, syncStatus } = useSelector((state: RootState) => state.map3Pending);

  useEffect(() => {
    // Clear existing timer if any
    if (queueTimer.current) {
      clearTimeout(queueTimer.current);
    }

    // If there are pending operations and we're not currently syncing
    if (operations.some((op) => op.status === 'pending') && syncStatus !== 'syncing') {
      queueTimer.current = setTimeout(() => {
        dispatch(processOperationQueue());
      }, QUEUE_PROCESS_DELAY);
    }

    // Cleanup
    return () => {
      if (queueTimer.current) {
        clearTimeout(queueTimer.current);
      }
    };
  }, [operations, syncStatus, dispatch]);
}
